"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class AcceptedResponse extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: true, description: 'Whether the request is accepted or not.' }),
    tslib_1.__metadata("design:type", Boolean)
], AcceptedResponse.prototype, "accepted", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '6816ebfd-9c4d-47d8-81a9-01057dc25540',
        description: 'The identifier of the resource that was changed',
    }),
    tslib_1.__metadata("design:type", String)
], AcceptedResponse.prototype, "resourceId", void 0);
exports.default = AcceptedResponse;
